/**
 * Parse Meta WhatsApp API error responses into user-friendly messages.
 * Shared between CreateTemplatePage and HomeCampaignPage.
 */
export const parseWhatsAppApiError = (error, fallbackMessage = '') => {
  const data = error?.response?.data;
  const userTitle = data?.error_user_title;
  const userMsg = data?.error_user_msg;
  const apiError = data?.error;

  if (userTitle || userMsg) {
    return [userTitle, userMsg].filter(Boolean).join(': ');
  }
  if (apiError) return apiError;
  if (error?.message) return error.message;
  return fallbackMessage;
};

// Códigos de permissão da Graph API: 10 e 200-299 são sempre permissão; o 100 é
// genérico ("parâmetro inválido") e só conta quando a Meta fala de permissão.
const isMetaPermissionError = (code, message = '') =>
  code === 10 ||
  (code >= 200 && code <= 299) ||
  (code === 100 && /permission/i.test(message));

/**
 * Mensagem do toast quando a exclusão de template falha. Recusa da Meta mostra
 * o motivo dela (permissão vira texto em português); o resto cai no genérico.
 */
export const deleteTemplateErrorMessage = (error, t) => {
  const data = error?.response?.data;
  if (data?.error === 'template_has_scheduled_campaigns') return data.message;
  if (data?.meta_code === undefined) {
    return t('CAMPAIGN.WHATSAPP_OFFICIAL.DELETE.ERROR');
  }
  if (isMetaPermissionError(data.meta_code, data.error)) {
    return t('CAMPAIGN.WHATSAPP_OFFICIAL.DELETE.META_PERMISSION');
  }
  return t('CAMPAIGN.WHATSAPP_OFFICIAL.DELETE.META_REFUSED', {
    reason: data.error,
  });
};
